import { CommonModule } from '@angular/common'
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core'
import { GenericComponentsModule } from '@helios/generic-components'
import { SecurityWebComponentPanelComponent } from './security-web-component-panel.component'

@NgModule({
  imports: [CommonModule, GenericComponentsModule],
  declarations: [SecurityWebComponentPanelComponent],
  exports: [SecurityWebComponentPanelComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SecurityWebComponentModule {}

export { SecurityWebComponentPanelComponent }
